// Firebase 설정 및 FCM 초기화
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase 설정 (환경변수 사용 권장)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "demo-api-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "acorn-bank-demo.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "acorn-bank-demo",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "acorn-bank-demo.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:demo-app-id",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-DEMO-MEASUREMENT-ID"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// FCM 메시징 인스턴스
let messaging = null;

try {
  // HTTPS 환경에서만 FCM 사용 가능
  if ('serviceWorker' in navigator && window.location.protocol === 'https:' || window.location.hostname === 'localhost') {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.log('FCM 초기화 실패:', error);
}

// VAPID 키 (Firebase Console에서 생성)
const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "demo-vapid-key-would-be-much-longer-in-real-project";

// FCM 토큰 요청
export const requestNotificationPermission = async () => {
  if (!messaging) {
    throw new Error('FCM을 사용할 수 없습니다. HTTPS 환경이 필요합니다.');
  }

  try {
    // 알림 권한 요청
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
      throw new Error('알림 권한이 거부되었습니다.');
    }

    // 서비스 워커 등록 확인
    if (!('serviceWorker' in navigator)) {
      throw new Error('서비스 워커를 지원하지 않는 브라우저입니다.');
    }

    // FCM 토큰 받기
    const token = await getToken(messaging, {
      vapidKey: vapidKey,
      serviceWorkerRegistration: await navigator.serviceWorker.register('/sw.js')
    });

    if (!token) {
      throw new Error('FCM 토큰을 받아올 수 없습니다.');
    }

    console.log('FCM 토큰:', token);
    return token;

  } catch (error) {
    console.error('FCM 토큰 요청 실패:', error);
    throw error;
  }
};

// 포그라운드 메시지 수신
export const onMessageListener = () => {
  if (!messaging) {
    return Promise.reject(new Error('FCM을 사용할 수 없습니다.'));
  }

  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('포그라운드 메시지 수신:', payload);

      // 브라우저 알림 표시
      if (payload.notification) {
        const { title, body, icon } = payload.notification;

        if (Notification.permission === 'granted') {
          new Notification(title || '도토리 저금통', {
            body: body || '새로운 알림이 있습니다.',
            icon: icon || '/favicon.ico',
            badge: '/favicon.ico',
            tag: 'acorn-bank',
            renotify: true
          });
        }
      }

      resolve(payload);
    });
  });
};

// 알림 권한 상태 확인
export const getNotificationPermission = () => {
  if (!('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

// FCM 사용 가능 여부 확인
export const isFCMSupported = () => {
  return !!(messaging && 'serviceWorker' in navigator);
};

// 데모용 플래그 (환경변수로 제어)
export const IS_DEMO_MODE = process.env.REACT_APP_FIREBASE_DEMO_MODE === 'true' ||
  process.env.REACT_APP_FIREBASE_API_KEY === undefined;

export default messaging;